import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageBanner from '../components/PageBanner';
import ProductCard from '../components/ProductCard';
import CartSidebar from '../components/CartSidebar';
import CheckoutModal from '../components/CheckoutModal';
import ReviewModal from '../components/ReviewModal';
import WhatsAppConfirmModal from '../components/WhatsAppConfirmModal';
import SEO from '../components/SEO';
import { useCart } from '../context/CartContext';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const Combos = () => {
  const { isOpen: cartOpen, setIsOpen: setCartOpen } = useCart();
  const [banner, setBanner] = useState(null);
  const [combos, setCombos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [placedOrder, setPlacedOrder] = useState(null);
  const [pendingOrder, setPendingOrder] = useState(null);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/banners`),
      axios.get(`${API}/categories`),
      axios.get(`${API}/products?active=true`),
    ]).then(([bannerRes, catRes, prodRes]) => {
      setBanner(bannerRes.data.find(b => b.type === 'combos'));
      const comboCat = catRes.data.find(c => c.name.toLowerCase() === 'combos');
      if (comboCat) {
        setCombos(prodRes.data.filter(p => p.category?._id === comboCat._id || p.category?.name?.toLowerCase() === 'combos'));
      }
    }).catch(console.error).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-cream" data-testid="combos-page">
      <SEO
        title="Combo Deals & Offers"
        description="Save more with specially curated combo deals on cakes, snacks and party items at Apni Dhani Bakery. Limited-time offers — order online today."
        path="/combos"
      />
      <Navbar onCartClick={() => setCartOpen(true)} />
      <PageBanner banner={banner} />

      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="mb-8">
          <h2 className="font-playfair text-3xl font-bold text-[#1F1410]">All Combo Deals</h2>
          <p className="text-[#7A6A63] mt-2">Save more with our specially curated combo offers</p>
          <div className="h-0.5 w-16 bg-[#7A1125] mt-3 rounded" />
        </div>

        {loading ? (
          <div className="flex justify-center py-20">
            <div className="w-8 h-8 border-2 border-[#7A1125] border-t-transparent rounded-full animate-spin" />
          </div>
        ) : combos.length === 0 ? (
          <div className="text-center py-20 text-[#7A6A63]">No combo deals available right now.</div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4" data-testid="combos-grid">
            {combos.map(p => (
              <ProductCard key={p._id} product={p} data_testid={`combo-card-${p._id}`} />
            ))}
          </div>
        )}
      </div>

      <Footer />
      <CartSidebar isOpen={cartOpen} onClose={() => setCartOpen(false)} onCheckout={() => { setCartOpen(false); setCheckoutOpen(true); }} />
      <CheckoutModal isOpen={checkoutOpen} onClose={() => setCheckoutOpen(false)} onOrderPlaced={(o) => { setCheckoutOpen(false); setPendingOrder(o); }} />
      {pendingOrder && <WhatsAppConfirmModal order={pendingOrder} onClose={() => { setPlacedOrder(pendingOrder); setPendingOrder(null); }} />}
      {placedOrder && <ReviewModal order={placedOrder} onClose={() => setPlacedOrder(null)} />}
    </div>
  );
};

export default Combos;
